<template>
  <div class="header">
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-form class="form" layout="vertical" :model="formState">
          <a-flex wrap="wrap" gap="small" align="flex-end">
            <EntityPicker
              v-model:value="formState.entity"
              default-behavior
              :show-all="false"
              label="Empresa"
              required
            />

            <CampaignPicker
              v-model:value="formState.portfolio"
              default-behavior
              :show-all="false"
              :entity="formState.entity"
              label="Campaña"
              required
            />

            <PlanSeparatedDatePicker
              v-model:startDate="formState.startDate"
              v-model:endDate="formState.endDate"
              startClass="form-item-picker"
              endClass="form-item-picker"
            />

            <!-- <a-form-item class="form-item-picker" name="startDate" label="Fecha de inicio" required>
              <a-date-picker
                v-model:value="formState.startDate"
                valueFormat="YYYY-MM-DD"
                format="DD/MM/YYYY"
              />
            </a-form-item>

            <a-form-item class="form-item-picker" name="endDate" label="Fecha de fin" required>
              <a-date-picker
                v-model:value="formState.endDate"
                valueFormat="YYYY-MM-DD"
                format="DD/MM/YYYY"
              />
            </a-form-item> -->
          </a-flex>
        </a-form>
      </a-col>
      <a-col>
        <a-row type="flex">
          <a-button
            type="primary"
            :disabled="isDisabled"
            @click="handleDownload"
            class="button-filter"
          >
            Descargar <DownloadOutlined />
          </a-button>
        </a-row>
      </a-col>
    </a-row>
  </div>

  <section class="info">
    Este reporte solo se podrá descargar al
    <br />
    aplicar los filtros
  </section>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from "vue";
import { DownloadOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

import {
  CapturedLeadsDownloadDto,
  sequenceReportService,
} from "@/app/reports/services/sequenceReport.service";
import { ResponseError } from "@/app/shared/utils/httpManager";

import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import PlanSeparatedDatePicker from "@/app/shared/components/pickers/PlanSeparatedDatePicker.vue";

const formState: Partial<CapturedLeadsDownloadDto> = reactive({
  entity: undefined,
  portfolio: undefined,
  startDate: undefined,
  endDate: undefined,
});

const isDisabled = computed(() => {
  let disabled = false;

  for (const key in formState) {
    if (!formState[key as keyof typeof formState]) {
      disabled = true;
      break;
    }
  }

  return disabled;
});

const loading = ref(false);

const handleDownload = async () => {
  loading.value = true;

  try {
    await sequenceReportService.downloadCapturedLeads(formState as CapturedLeadsDownloadDto);
    // downloadFile(response, "strategies_report.xlsx", { useResponseFileName: true });
    message.success("Se ha encolado la descarga");
  } catch (error) {
    let errorMessage = "Ha ocurrido un error";

    if (error instanceof ResponseError) errorMessage = error.getErrorMessage();

    message.error(errorMessage);
    console.error(error);
  }

  loading.value = false;
};
</script>

<style scoped lang="sass">
.header
  margin-top: 12px

.form
  display: flex
  gap: 8px

  > .ant-form-item
      width: 240px
      margin: 0

.info
  display: grid
  place-content: center
  text-align: center
  color: $gray-7
  font-size: 20px
  font-weight: 400
  margin-top: 150px

.ant-form-item.form-item-picker
  width: 150px

.button-filter
  margin-top: 23px
  margin-left: auto
</style>
